import React, { useState } from 'react';
// import CouponListItem from './CouponListItem';
import Toggle from '../../../../Components/Toggle/Toggle';

function CouponsList() {
    const [activeList, setActiveList] = useState('active-coupons');

    const handleSelection = (event) => {
        setActiveList(event.target.id);
    }

    return (
        <div className='flex flex-col gap-3 w-full'>
            <Toggle 
                items={{
                    firstItem: 'Active Coupons',
                    secondItem: 'All Coupons',
                    firstItemID: 'active-coupons',
                    secondItemID: 'all-coupons', 
                    activeList: activeList
                }} 
                onClick={handleSelection} 
            />

            {/* List of Coupons */}
            <div className="border border-[#EAEAEA] rounded-lg">
                <div className="flex bg-[#F5F5F5] font-semibold text-[#666666]">
                    <h2 className="w-[20%] px-[10px] py-2 text-[16px] max-[1280px]:text-[14px] leading-8 max-[1280px]:leading-6">Coupon Name</h2>
                    <h2 className="w-[14%] px-[10px] py-2 text-[16px] max-[1280px]:text-[14px] leading-8 max-[1280px]:leading-6">Redemption Rate</h2>
                    <h2 className="w-[11%] px-[10px] py-2 text-[16px] max-[1280px]:text-[14px] leading-8 max-[1280px]:leading-6">Total Orders</h2>
                    <h2 className="w-[11%] px-[10px] py-2 text-[16px] max-[1280px]:text-[14px] leading-8 max-[1280px]:leading-6">Total Sales</h2>
                    <h2 className="w-[13%] px-[10px] py-2 text-[16px] max-[1280px]:text-[14px] leading-8 max-[1280px]:leading-6">New Customers</h2>
                    <h2 className="w-[13%] px-[10px] py-2 text-[16px] max-[1280px]:text-[14px] leading-8 max-[1280px]:leading-6">Ret. Customers</h2>
                    <h2 className="w-[18%] px-[10px] py-2 text-[16px] max-[1280px]:text-[14px] leading-8 max-[1280px]:leading-6">Apply Vs Purchase Ratio</h2>
                </div>

                {/* List Items */}
                {/* <CouponListItem /> */}
            </div>
        </div>
    );
}

export default CouponsList;
